import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import translation from "./ja/translation.json"

i18next
  .use(initReactI18next)
  .init({
    debug: true,
    lng: "ja",
    resources: {
      ja: {
        translation
      }
    },
  });

export default i18next;


